// TODO: PROVIDE PROPS

import React from 'react'
import { Checklist } from '@cmd/library'
import { rupiah, moneyToString } from '@cmd/library/lib/utils/function';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExchangeAlt, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { Link, useHistory } from 'react-router-dom';

import './Item.css'

const checkComparison = (isCar, product_id) => {

  if(localStorage.getItem("comparison1") != null && localStorage.getItem("comparison1").split(",")[0] == `${isCar}` && localStorage.getItem("comparison1").split(",")[1] == `${product_id}`) {
    return 
  } else if (localStorage.getItem("comparison2") != null && localStorage.getItem("comparison2").split(",")[0] == `${isCar}` && localStorage.getItem("comparison2").split(",")[1] == `${product_id}`) {
    return 
  } else if (localStorage.getItem("comparison3") != null && localStorage.getItem("comparison3").split(",")[0] == `${isCar}` && localStorage.getItem("comparison3").split(",")[1] == `${product_id}`) {
    return
  } else {
    if (localStorage.getItem("comparison1") == null) {
      localStorage.setItem("comparison1", `${isCar},${product_id}`);
  } else if (localStorage.getItem("comparison2") == null) {
      localStorage.setItem("comparison2", `${isCar},${product_id}`);
  } else if (localStorage.getItem("comparison3") == null) {
      localStorage.setItem("comparison3", `${isCar},${product_id}`);
  } else {
      localStorage.setItem("comparison1", `${isCar},${product_id}`);
  } 
  }
}

const Item = (props) => {
  const history = useHistory()
  return (
    <div className="product-item-wrapper">
      <div className="product-item-image">
        <div className="product-item-image-wrapper">
          <img src={props.image} alt="" />
        </div>
        {props.detail.condition == "Capella Certified" ? (
        <div className="product-item-certified">
          <img src={require('../../assets/img/capella-certified.png')} alt=""/>
        </div>
        ) : (
          <div className="product-item-new">
            <span>{props.detail.condition}</span>
          </div>
        )}
      </div>
      <div className="product-item-text">
        <div className="product-item-title">
          <div>
            <p className="mb--0">
              <strong>{props.name}</strong>
              <span className="ml--1 text--color-gold text--size-14 compare-icon">
                <Link to={`/comparasion`} onClick={() => checkComparison(props.detail.isCar, props.detail.id)}>
                  <FontAwesomeIcon icon={faExchangeAlt} />
                  <span className="compare-link">
                    <span className="text--size-14">Bandingkan Kendaraan</span>
                  </span>
                </Link>
              </span>
            </p>
          </div>
        </div>
        <div className="product-item-spec">
          <span>{props.detail.type}</span>
          <span>{props.detail.location}</span>
          <span>{props.detail.mileage}</span>
        </div>
        <div className="product-item-price">
          <p>
            <span className="main-price">{rupiah(props.detail.price)}</span>
            <span className="installment">{props.detail.installment}</span>
          </p>
        </div>
        {
          props.detail.belowMarketPrice != null && props.detail.belowMarketPrice >= 0 && (
            <div className="product-item-contact">
              <div className="product-item-contact-wrapper fx align-items-center">
                <span className="mr--1">
                  {props.detail.belowMarketPrice > 0 ? (
                    <div className="checklist-wrapper">
                      <span>
                        <FontAwesomeIcon icon={faArrowDown} />
                      </span>
                    </div>
                  ) : props.detail.belowMarketPrice < 0 ? (
                    <div className="checklist-wrapper">
                      <span>
                        <FontAwesomeIcon icon={faArrowUp} />
                      </span>
                    </div>
                  ) : (<div></div>)}
                </span>
                <p className="text--size-14">{props.detail.belowMarketPrice > 0 ? (
                    `${moneyToString(Math.ceil(props.detail.belowMarketPrice / 1000000) * 1000000)} dibawah market`
                  ) : props.detail.belowMarketPrice < 0 ? (
                    `${moneyToString(Math.ceil(props.detail.belowMarketPrice * -1/ 1000000) * 1000000)} diatas market`
                  ) : (`Sesuai harga market`)}</p>
              </div>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default Item
